var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContestadas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.4,
    stroke: "#7D4196",
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3244_3908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8 4.8H11.2C11.64 4.8 12 5.16 12 5.6V10.4C12 10.84 11.64 11.2 11.2 11.2H4.8C4.36 11.2 4 10.84 4 10.4V5.6C4 5.16 4.36 4.8 4.8 4.8Z",
    fill: "#7D4196",
    stroke: "#7D4196",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.60001L8 8.40001L4 5.60001",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3244_3908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 9.6,
    fill: "white",
    transform: "translate(3.2002 3.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContestadas);
export default __webpack_public_path__ + "static/media/icon-contestadas.8768fd065f3bd9a6927c7c88f3c47b48.svg";
export { ForwardRef as ReactComponent };